import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';


const firebaseConfig = {
    apiKey: "AIzaSyBBaLgx7V4XeCeE8KNMJl2-sCHvsukMLmI",
    authDomain: "shivamba-56bbf.firebaseapp.com",
    projectId: "shivamba-56bbf",
    storageBucket: "shivamba-56bbf.firebasestorage.app",
    messagingSenderId: "797607866036",
    appId: "1:797607866036:web:7a5424ebcdb147d165b1e1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;